/**
 * HTML escaping - every piece of content text the renderer interpolates
 * goes through these. Raw insertion is reserved for validated freeform html.
 */
import { isAllowedUrl } from '../policy/index.js';

const HTML_REPLACEMENTS: ReadonlyMap<string, string> = new Map([
  ['&', '&amp;'],
  ['<', '&lt;'],
  ['>', '&gt;'],
  ['"', '&quot;'],
  ["'", '&#39;'],
]);

/** Escape text for use in element content or attribute values. */
export function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (char) => HTML_REPLACEMENTS.get(char) ?? char);
}

/**
 * Escape a URL for an href/src attribute. Delegates the scheme/shape
 * decision to the ONE canonical policy (isAllowedUrl) so the render path
 * and the write-time policy never drift: http(s)/mailto/tel, root-relative,
 * or in-page anchors pass; everything else (javascript:/data:/file:/
 * vbscript:, protocol-relative, backslash, relative-without-root) becomes '#'.
 */
export function safeUrl(url: string): string {
  return isAllowedUrl(url) ? escapeHtml(url.trim()) : '#';
}
